import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/account/:name',
    name: 'AccountSettingsMain',
    component: () => import('@/views/client/overview/AccountSettingsView.vue'),
    meta: { requiresAuth: true, showAccountHeader: true },
  },
  {
    path: '/account/edit/:name',
    name: 'EditAccountView',
    component: () => import('@/views/client/overview/EditAccountView.vue'),
    meta: { requiresAuth: true, showAccountHeader: true },
  },
  {
    path: '/users',
    name: 'UsersViewClient',
    component: () => import('@/views/client/users/UserClient.vue'),
    meta: { requiresAuth: true, showAccountHeader: true },
  },
  {
    path: '/users/create-user',
    name: 'CreateUserClient',
    component: () => import('@/views/client/users/CreateUser.vue'),
    meta: { requiresAuth: true },
  },
]

export default routes
